/* eslint-disable */
import { useEffect, useState, useContext } from 'react'
import styles from './index.module.scss'
import { FormButton } from '../../components/core/button'
import { GeneralInput } from '../../components/core/input'
import StepLine from '../../components/core/stepLine'
import { Help, SearchIcon, Plus, Close } from '../../icons'
import { PageContext } from '../../context/PageContextProvider'
import ServicesAPI from '../../api/services'
import Loading from '../../components/pages/loading'
import text from './text.json'

const GetService2 = ({ className }) => {
  const { language } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [data, setData] = useState([])
  const [options, setOptions] = useState([])
  const [choices, setChoices] = useState([])
  useEffect(() => {
    (async () => {

    const { data } = await ServicesAPI.getCategories()
    await setData(data)
    await setLoad(true)
  
    })();
  }, [])
  const [input, setInput] = useState('')
  const addHandle = (item) => {
    if (options.includes(item)) {
      let x = [...options]
      const index = x.indexOf(item)
      if (index > -1) {
        x.splice(index, 1)
        setOptions(x)
      }
    } else {
      let x = [...options]
      x.push(item)
      setOptions(x)
    }
  }
  const optionHandle = () => {
    let choice = [...choices]
    let inp = input.trim()
    if (inp !== '' && !options.includes(inp) && !choices.includes(inp)) {
      choice.push(inp)
      setChoices(choice)
      setInput('')
    }
  }
  const removeHandle = (item) => {
    let choice = [...choices]
    let index = choice.indexOf(item)
    choice.splice(index, 1)
    setChoices(choice)
  }
  const sendAppeal = async () => {
    let data = await JSON.parse(sessionStorage.getItem('service'))
    let new_opt = options.map((item) => (typeof item === 'string' ? item : item?.[language] || item?.title?.[language] || item?.name || ''))
    let arr = await [...choices, ...new_opt]
    data.options = await arr
    let response = await ServicesAPI.insert(data)
    if (response.status === 200) {
      sessionStorage.removeItem('service')
      window.location.href = '/success/v2'
    }
  }
  return load ? (
    <section className={`${className} ${styles.container}`}>
      <StepLine active={1} data={text.steps} />
      <div className={`${styles.content}`}>
        <h2>
          <Help /> {text.question[language]}
        </h2>
        <div className={styles.header}>
          <div className={styles.add}>
            <span>{text.label[language]}</span>
            <div>
              <GeneralInput
                value={input}
                onInput={(e) => setInput(e.target.value)}
                placeholder={text.enter[language]}
              />
              <button
                onClick={() => {
                  optionHandle()
                }}
              >
                <Plus />
                {text.add[language]}
              </button>
            </div>
          </div>
        </div>
        <div className={styles.table}>
          <ul>
            <p>{text.services[language]}</p>
            {data.map((item, i) => (
              <li
                style={
                  options.includes(item['ENG']) ? { color: '#166FE5' } : null
                }
                onClick={() => {
                  addHandle(item['ENG'])
                }}
                key={i}
              >
                {item[language]}
              </li>
            ))}
          </ul>
          <ul>
            <p>{text.special[language]}</p>
            <div>
              {choices.map((item, i) => (
                <li key={i}>
                  {item}
                  <Close
                    button
                    onClick={() => {
                      removeHandle(item)
                    }}
                  />
                </li>
              ))}
            </div>
          </ul>
        </div>

        <FormButton onClick={() => sendAppeal()}>
          {text.button[language]}
        </FormButton>
      </div>
    </section>
  ) : (
    <Loading />
  )
}

export default GetService2
